
import { Edit, SelectInput, SimpleForm, TextInput } from "react-admin";
import { Col, Row } from "../../components/grid.component";
import { Text } from "../../components/typography.component";

const Title = ({ record }: any) => (
  <Text gutterBottom={false}>{record?.name || 'Produto'}</Text>
);

export const ProductsEdit = (props: any) => {
  return (
    <Edit title={<Title />} {...props}>
      <SimpleForm>
        <Row spacing={2}>
          <Col md={6}>
            <TextInput fullWidth source="name" label="Nome" />
          </Col>
          <Col md={6}>
            <SelectInput
              fullWidth
              label="Categoria"
              source="category"
              choices={[
                { id: "Course", name: "Curso" },
                { id: "Software", name: "Software" },
              ]}
              optionText="name"
              optionValue="id"
            />
          </Col>
        </Row>
      </SimpleForm>
    </Edit>
  );
};
